<template>
  <div class="reservation-form-pdf-page">
    <div v-if="!viewerUrl" class="reservation-form-pdf-page__message">{{ errorMessage }}</div>
    <template v-else>
      <div v-if="isLoading" class="reservation-form-pdf-page__loader">
        <div class="reservation-form-pdf-page__spinner"></div>
        <div class="reservation-form-pdf-page__loader-text">Loading PDF...</div>
      </div>
      <iframe
        :src="viewerUrl"
        class="reservation-form-pdf-page__frame"
        title="Reservation Form"
        @load="onFrameLoaded"
      />
    </template>
  </div>
</template>

<script>
import JwtService from "@/core/services/jwt.service";

export default {
  name: "ReservationFormPdf",
  data() {
    return {
      viewerUrl: "",
      errorMessage: "Unable to load reservation form.",
      isLoading: true,
    };
  },
  created() {
    if (!JwtService.getToken()) {
      this.$router.push({ path: "/login" });
      return;
    }

    const token = this.$route.params.token;
    if (!token) {
      return;
    }

    const baseUrl = (process.env.VUE_APP_ADMIN_API_URL || "").replace(/\/?$/, "/");
    this.viewerUrl = `${baseUrl}api/listingreservationformpdf/view/${encodeURIComponent(token)}?_=${Date.now()}`;
  },
  methods: {
    onFrameLoaded() {
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.reservation-form-pdf-page {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: #f5f5f5;
  position: relative;
}

.reservation-form-pdf-page__frame {
  width: 100%;
  height: 100vh;
  border: 0;
  display: block;
}

.reservation-form-pdf-page__message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
}

.reservation-form-pdf-page__loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  z-index: 2;
}

.reservation-form-pdf-page__spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #d5d5d5;
  border-top-color: #00004d;
  border-radius: 50%;
  animation: reservation-form-pdf-spin 0.8s linear infinite;
}

.reservation-form-pdf-page__loader-text {
  margin-top: 14px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  color: #333;
}

@keyframes reservation-form-pdf-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
